import {
  EVENT_SET_USER_PREFERENCES,
  EventSetUserPreferencesPayload,
} from '@weblite/ts-action/user-preferences'

import { serverSub } from '$func/subscription'
import { userPreferencesStorage } from './storage'

serverSub.subscribe(
  EVENT_SET_USER_PREFERENCES,
  (payload: EventSetUserPreferencesPayload) =>
    userPreferencesStorage.set(payload),
)
